/**
 * Created by shubham on 20/11/18.
 */

import { Component } from '@angular/core';
import { APPCONFIG } from '../../../config';
import { MdDialog } from '@angular/material';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DialogComponent } from '../../../dialog/dialog.component';


@Component({
    selector: 'add-business-user',
    template: require('./add-business-unit.component.html')
})
export class AddBusinessUnitForUserComponent {

    dialogRef;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    settings = {};
    country = [];
    businessUnits = [];
    applications = [];
    AddBusinessUnitForm: FormGroup;
    AddBusinessUnitFormDetails: any;
    isDisabled = true;
    selectedBusinessUnit: any;

    constructor(private sessionHandler:SessionHandler, public httpService : HttpService, public dialog: MdDialog, private formBuilder: FormBuilder) {

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        if(this.isServiceOwner){
            this.getBusinessUnitAndCountry();
        }
    }

    public getBusinessUnitAndCountry() {
        this.httpService.getRequest('applicationOperationApi/v1/initNewApplicationRequest').subscribe(
            res => { this.saveBusinessUnitAndCountry(res); },
            err => { this.httpService.onEnd(); }
        );

    }
    public saveBusinessUnitAndCountry(res){
        if(res){
            this.country['id'] = res.countryId;
            this.country['name'] = res.countryName;

            if(res.availableBusinessUnits){
                this.businessUnits = res.availableBusinessUnits;
            }

            if(res.defaultBusinessUnit){
                this.selectedBusinessUnit = res.defaultBusinessUnit.id;
            }
        }
        this.buildForm();
        this.httpService.onEnd();
    }

    buildForm() {
        this.AddBusinessUnitForm = this.formBuilder.group({
            country: this.formBuilder.control({value: this.country['name'], disabled: true}),
            businessUnitId: this.formBuilder.control(null, [Validators.required]),
            applicationData: this.formBuilder.control(null, [Validators.required]),
            customerNumber: this.formBuilder.control(null, [Validators.required])
        });
        this.AddBusinessUnitForm.valueChanges.subscribe(data => {
            this.AddBusinessUnitFormDetails = this.AddBusinessUnitForm.getRawValue();

            this.AddBusinessUnitFormDetails['applicationId'] = [];
            for (let d in this.AddBusinessUnitFormDetails.applicationData){
                this.AddBusinessUnitFormDetails['applicationId'].push(this.AddBusinessUnitFormDetails.applicationData[d]['id']);
            }

            this.AddBusinessUnitFormDetails.validate = this.AddBusinessUnitForm.valid;
        });

        this.AddBusinessUnitForm.get('businessUnitId').valueChanges.subscribe(data=> {
            const arrayControl = <FormArray>this.AddBusinessUnitForm.controls['applicationData'];
            arrayControl.controls = [];
            this.applications = [];

            if(data != null){
                this.getApplicationsByBusinessUnit(data);
            }
        });

        this.AddBusinessUnitForm.get('applicationData').valueChanges.subscribe(data=> {

            if(data != null){
                for(let app of data){
                    if(app.customerNumberRequired && app.customerNumberRequired != null){
                        this.AddBusinessUnitForm.get('customerNumber').setValidators(null);
                        this.AddBusinessUnitForm.get('customerNumber').updateValueAndValidity();
                        break;
                    }
                }
            }
        });
    }

    public getApplicationsByBusinessUnit(businessUnitId) {
        this.httpService.getRequest('applicationOperationApi/v1/getUnsubscribedApplicationsForPartner/'+businessUnitId).subscribe(
            res => { this.saveApplicationsByBusinessUnit(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    saveApplicationsByBusinessUnit(res) {
        if(res && res.availableApplications){

            if(res.availableApplications){
                this.applications = res.availableApplications;
            }

            if(res.customerNumber) {
                this.AddBusinessUnitForm.get('customerNumber').setValue(res.customerNumber);
            }
        }
        this.httpService.onEnd();
    }

    public saveBusinessUnitData(){
        this.httpService.postRequest(this.AddBusinessUnitFormDetails,'applicationOperationApi/v1/subscribeApplications').subscribe(
            res => { this.saveBusinessUnitDataResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }
    public saveBusinessUnitDataResponse(res){
        if(res){
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "app_add_success";
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/request-application/list';
            });
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    }

    ngOnInit() {
        this.buildForm();

        this.settings = {
            singleSelection: false,
            text:"Select Applications",
            labelKey: "name",
            selectAllText:'Select All',
            unSelectAllText:'UnSelect All',
            classes:"myclass custom-class"
        };
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/add-business-unit/add-business-unit.component.ts